import React from 'react';

import { confluenceIcon } from '@atlaskit/logo/raw-icons';

/** Decorative product icon accompanying the localized Confluence attribution name. */
export const ConfluenceAttributionIcon = (): React.JSX.Element => (
	<img src={confluenceIcon} alt="" width={16} height={16} />
);
